import { useEffect, useLayoutEffect } from 'react'
import { stateRef } from './store'
import type { AuthState } from './stateTypes'

export const initialDocTitle = document.title // keep the orignal title
export const setPageTitle = (title?: string | null | undefined): string => {
  const auth = stateRef.current.auth || {} as AuthState
  const {
    tsg_id,
    tsg_name = tsg_id && auth.tsgs?.get(tsg_id)?.display_name,
  } = auth
  const titleSuffix = tsg_name ? `${initialDocTitle} (${tsg_name})` : initialDocTitle
  const finalTitle = title ? `${title} - ${titleSuffix}` : titleSuffix
  if (document.title !== finalTitle) {
    document.title = finalTitle
  }
  return finalTitle
}

export const useTsgTitleSync = (auth: AuthState | undefined) => {
  useLayoutEffect(() => {
    setPageTitle()
  }, [auth?.tsg_id])
}
export const useResetPageTitle = () => {
  useLayoutEffect(() => {
    setPageTitle()
  }, [])
}
export const usePageTitle = (title?: string | null | undefined) => {
  useEffect(() => {
    setPageTitle(title)
  }, [title])
}
